import request from '@/utils/request'

export function categoryList(data) {
    return request({
        url: '/backend/mall/categoryList',
        method: 'post',
        data: data
    })
}
export function createUpdateCategory(data) {
    return request({
        url: '/backend/mall/createUpdateCategory',
        method: 'post',
        data: data
    })
}
export function getCategoryInfo(data) {
    return request({
        url: '/backend/mall/getCategoryInfo',
        method: 'post',
        data: data
    })
}
export function deleteCategory(data) {
    return request({
        url: '/backend/mall/deleteCategory',
        method: 'post',
        data: data
    })
}
export function updateCategorySort(data) {
    return request({
        url: '/backend/mall/updateCategorySort',
        method: 'post',
        data: data
    })
}
export function updateCategoryStatus(data) {
    return request({
        url: '/backend/mall/updateCategoryStatus',
        method: 'post',
        data: data
    })
}


export function categoryProductList(data) {
    return request({
        url: '/backend/mall/categoryProductList',
        method: 'post',
        data: data
    })
}
export function categoryAddProduct(data) {
    return request({
        url: '/backend/mall/categoryAddProduct',
        method: 'post',
        data: data
    })
}
export function categoryDeleteProduct(data) {
    return request({
        url: '/backend/mall/categoryDeleteProduct',
        method: 'post',
        data: data
    })
}
export function updateCategoryProductSort(data) {
    return request({
        url: '/backend/mall/updateCategoryProductSort',
        method: 'post',
        data: data
    })
}

export function productRecommendList(data) {
    return request({
        url: '/backend/mall/productRecommendList',
        method: 'post',
        data: data
    })
}

export function productRecommendAddProduct(data) {
    return request({
        url: '/backend/mall/productRecommendAddProduct',
        method: 'post',
        data: data
    })
}

export function productRecommendDeleteProduct(data) {
    return request({
        url: '/backend/mall/productRecommendDeleteProduct',
        method: 'post',
        data: data
    })
}

export function configInfo(data) {
    return request({
        url: '/backend/mall/configInfo',
        method: 'post',
        data: data
    })
}

export function saveHomeConfig(data) {
    return request({
        url: '/backend/mall/saveHomeConfig',
        method: 'post',
        data: data
    })
}

export function moduleList(data) {
    return request({
        url: '/backend/mall/moduleList',
        method: 'post',
        data: data
    })
}

export function updateSort(data) {
    return request({
        url: '/backend/mall/updateSort',
        method: 'post',
        data: data
    })
}

export function updateOnline(data) {
    return request({
        url: '/backend/mall/updateOnline',
        method: 'post',
        data: data
    })
}

export function createModule(data) {
    return request({
        url: '/backend/mall/createModule',
        method: 'post',
        data: data
    })
}

export function deleteModule(data) {
    return request({
        url: '/backend/mall/deleteModule',
        method: 'post',
        data: data
    })
}

export function getCouponList(data) {
    return request({
        url: '/backend/mall/getCouponList',
        method: 'post',
        data: data
    })
}

export function updateCouponSort(data) {
    return request({
        url: '/backend/mall/updateCouponSort',
        method: 'post',
        data: data
    })
}

export function updateCouponOnline(data) {
    return request({
        url: '/backend/mall/updateCouponOnline',
        method: 'post',
        data: data
    })
}

export function getItemInfo(data) {
    return request({
        url: '/backend/mall/getItemInfo',
        method: 'post',
        data: data
    })
}

export function updateCouponInfo(data) {
    return request({
        url: '/backend/mall/updateCouponInfo',
        method: 'post',
        data: data
    })
}

export function deleteCouponInfo(data) {
    return request({
        url: '/backend/mall/deleteCouponInfo',
        method: 'post',
        data: data
    })
}

export function getFlashSaleList(data) {
    return request({
        url: '/backend/mall/getFlashSaleList',
        method: 'post',
        data: data
    })
}

export function updateFlashSaleInfo(data) {
    return request({
        url: '/backend/mall/updateFlashSaleInfo',
        method: 'post',
        data: data
    })
}

export function updateFlashSaleSort(data) {
    return request({
        url: '/backend/mall/updateFlashSaleSort',
        method: 'post',
        data: data
    })
}

export function updateFlashSaleOnline(data) {
    return request({
        url: '/backend/mall/updateFlashSaleOnline',
        method: 'post',
        data: data
    })
}

export function deleteFlashSaleInfo(data) {
    return request({
        url: '/backend/mall/deleteFlashSaleInfo',
        method: 'post',
        data: data
    })
}

export function getProductList(data) {
    return request({
        url: '/backend/mall/getProductList',
        method: 'post',
        data: data
    })
}

export function updateProductSort(data) {
    return request({
        url: '/backend/mall/updateProductSort',
        method: 'post',
        data: data
    })
}

export function updateProductOnline(data) {
    return request({
        url: '/backend/mall/updateProductOnline',
        method: 'post',
        data: data
    })
}

export function deleteProductInfo(data) {
    return request({
        url: '/backend/mall/deleteProductInfo',
        method: 'post',
        data: data
    })
}

export function updateProductInfo(data) {
    return request({
        url: '/backend/mall/updateProductInfo',
        method: 'post',
        data: data
    })
}
export function getProductInfo(data) {
    return request({
        url: '/backend/mall/getProductInfo',
        method: 'post',
        data: data
    })
}

export function getModuleInfo(data) {
    return request({
        url: '/backend/mall/getModuleInfo',
        method: 'post',
        data: data
    })
}
export function updateModuleInfo(data) {
    return request({
        url: '/backend/mall/updateModuleInfo',
        method: 'post',
        data: data
    })
}